/**
 * 格式化
 */


// 驾驶持续时间，秒
export function duration(second) {
  let result = '';
  let minutes = Math.round(second / 60);

  if (minutes > 60) {
    let hours = Math.round(minutes / 60);
    minutes = minutes % 60;

    result = `${hours}小时${minutes}分钟`;
  } else {
    result = minutes + '分钟';
  }

  return result;
}

// 油
export function oil(liter) {
  if (liter > 10 || liter < 0.1) {
    return liter.toFixed(0);
  } else {
    return liter.toFixed(1);
  }
}

// 距离
export function distance(meter) {
  let kilometers = meter / 1000;

  if (kilometers > 10 || kilometers < 0.1) {
    return kilometers.toFixed(0);
  } else {
    return kilometers.toFixed(1);
  }
}


/**
 * timeZoneDiff 要模拟的时区与当前时区的差
 */
export function date(timestamp, str, timeZoneDiff = 0) {
  let date = new Date(timestamp + (timeZoneDiff * 3600000));
  let N = ['日', '一', '二', '三', '四', '五', '六'];
  let map = {
    'MM': zeroFill(date.getMonth() + 1),
    'dd': zeroFill(date.getDate()),
    'N': N[date.getDay()]
  };
  let key;

  for (key in map) {
    str = str.replace(key, map[key]);
  }

  str = str.replace(/y+/g, function (match) {
    return (date.getFullYear() + '').substr(4 - match.length);
  });

  return str;
}

function zeroFill(num) {
  return num >= 10 ? `${num}` : `0${num}`;
}



// WEBPACK FOOTER //
// ./src/utils/format.js